<template>
  <div class="mdc-layout-container mdc-container">
    <!-- Outlet for children routes -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Business'
}
</script>

<style></style>
